export default __webpack_public_path__ + "static/media/kitchen3-after3-1440w.d0aabab2.avif";